import { render, staticRenderFns } from "./custom-element.vue?vue&type=template&id=fa239bbc&scoped=true&"
import script from "./custom-element.vue?vue&type=script&lang=js&"
export * from "./custom-element.vue?vue&type=script&lang=js&"
import style0 from "./custom-element.vue?vue&type=style&index=0&id=fa239bbc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa239bbc",
  null
  
)

export default component.exports